import React, { Component } from 'react';
import Create from './Create';
import Info from './Info';
import Learn from './Learn';
import Explore from './Explore';
import NoPage from './NoPage';
import MyProjects from './MyProjects'


import NavigationBar from '../components/NavigationBar'
import { Route, Switch, Redirect } from 'react-router-dom';


import ReactGA from 'react-ga';
import Landing from './Landing';
import Login from './Login';
const tracking_id = "UA-110956293-9";

ReactGA.initialize(tracking_id)

ReactGA.pageview("/landingpage");



class ImagiApp extends Component {
    render() {
        return (
            <div  style={{backgroundColor:'#343434',minHeight:"100vh"}} >

                    
                    <Route path="/app" component={NavigationBar} />
                    <Route exact path="/" >
                        <Redirect to="/landing"/>
                    </Route>
                    <Switch>
                    <Route exact  path="/landing" component={Landing}/>
                    <Route exact path="/login" component={Login} />
                    <Route exact activeClassName="active" path="/app/create" component={Create} />
                    <Route exact activeClassName="active" path="/app/explore" component={Explore} />
                    <Route exact path="/app/learn" component={Learn} />
                    <Route exact activeClassName="active" path="/app/my-projects" component={MyProjects} />
                    <Route exact path="/app/info" component={Info} />
                    
                    <Route component={NoPage}/>
                    </Switch>
              

            </div>


        )
    }
}
export default ImagiApp;